function isValidIPv4(ip) {
  if (typeof ip !== "string") return false;

  const parts = ip.trim().split(".");
  if (parts.length !== 4) return false;

  return parts.every((part) => {
    if (!/^\d+$/.test(part)) return false;
    const num = Number(part);
    return num >= 0 && num <= 255;
  });
}

function ipToInt(ip) {
  if (!isValidIPv4(ip)) return null;

  return (
    ip
      .trim()
      .split(".")
      .reduce((acc, octet) => (acc << 8) + Number(octet), 0) >>> 0
  );
}

function isInSubnet(ip, cidr) {
  if (!isValidIPv4(ip) || typeof cidr !== "string") return false;

  const [range, bitsStr] = cidr.split("/");
  const maskBits = bitsStr === undefined ? 32 : Number(bitsStr);

  if (!isValidIPv4(range)) return false;
  if (!Number.isInteger(maskBits) || maskBits < 0 || maskBits > 32)
    return false;

  const ipInt = ipToInt(ip);
  const rangeInt = ipToInt(range);

  if (ipInt === null || rangeInt === null) return false;

  const mask = maskBits === 0 ? 0 : (0xffffffff << (32 - maskBits)) >>> 0;

  return (ipInt & mask) === (rangeInt & mask);
}

export function isAllowedIP(ip, whitelist = []) {
  if (!isValidIPv4(ip) || !Array.isArray(whitelist)) return false;

  const normalizedIP = ip.trim();

  return whitelist.some((entry) => {
    if (typeof entry !== "string") return false;

    const normalizedEntry = entry.trim();

    // Exact IP match
    if (!normalizedEntry.includes("/")) {
      return normalizedIP === normalizedEntry;
    }

    return isInSubnet(normalizedIP, normalizedEntry);
  });
}
